import { BrandliveEvent, LanguagesAbbr, Session } from "../types/working-model";
import { getNavigatorLanguage } from "./utils";


// this function returns a default language code based on the event passed in
export function getDefaultLanguageCode(session: Session | undefined | null): string {

	if (session) {
		// if session has default language, return
		if (session.default_language)
			return session.default_language;

		// if navigator has a language return
		const lang = getNavigatorLanguage();
		if (lang) {
			return lang;
		}

		// if no default language, return first language listed for session
		if (session.languages.length)
			return session.languages[0];

		// if no languages listed in session, return english
		return 'en';
	}
	// default return english
	return 'en';
}

export function getHomepageDefaultLanguage(event?: BrandliveEvent | null): LanguagesAbbr {
	return (event?.settings.i18n?.base as LanguagesAbbr) || "en";
}